import config from '../../../../config';
import { LoaderDex } from '../../components/alerts/Loader';
import { LoadingTradingInfo } from '../../research/[address]';

export const LoadingComponent = () => {
  return (
    <>
      {!config.isTelegramBrowser && (
        <div className="hidden lg:block">
          <div className="xxs:w-full  flex xxs:flex-col-reverse lg:flex-row xxs:gap-2 ">
            <div className="flex flex-col w-full lg:w-full h-full xxs:gap-2">
              <div className="w-full space-y-3 flex flex-col">
                <div
                  className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-full"
                  style={{ minWidth: 12, maxWidth: '128px' }}
                >
                  &nbsp;
                </div>
                <div
                  className="xxs:h-2 my-1  rounded-full xxs:bg-dex-black-700  w-full"
                  style={{ minWidth: 12, maxWidth: '64px' }}
                >
                  &nbsp;
                </div>
                <div
                  className="xxs:h-2 my-1 rounded-full xxs:bg-dex-black-700 w-full"
                  style={{ minWidth: 12, maxWidth: '64px' }}
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
          <div className="xxs:w-full lg:w-4/5 xxs:bg-dex-black-800 xxs:h-[300px] md:h-[400px] flex items-center justify-center">
            <LoaderDex />
          </div>
          <div
            className="xxs:h-2 my-1 rounded-full xxs:bg-black-800 w-full"
            style={{ minWidth: 12, maxWidth: '64px' }}
          >
            &nbsp;
          </div>
        </div>
      )}
      <div className="lg:hidden">
        <div className="xxs:space-y-2">
          <div className="w-full xxs:h-[66px] xxs:p-2">
            <div
              className="xxs:h-2 my-1 rounded-full xxs:bg-dex-black-700 w-full"
              style={{ width: '40px' }}
            >
              &nbsp;
            </div>
          </div>
          <div className="xxs:space-y-2 w-full">
            <div className="flex flex-col w-full lg:w-full h-full xxs:gap-2">
              <div className="flex flex-col lg:flex-row w-full h-full">
                {[1, 2, 3, 4, 5].map((id) => (
                  <LoadingTradingInfo key={id + 'main'} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
